<!--駅選択に伴う注意文-->
<template>
  <div>
    <p class="help-block" v-html="newlineConvert(note)" />
  </div>
</template>

<script>
export default {
  name: "MbFromStationCaution",
  props: {
    note: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.help-block {
  margin: 10px 0 10px 0 !important;
  font-size: 13px !important;
  text-align: right;
  line-height: 17px;
  white-space: pre-wrap;
}
</style>
